import ErrorIcon from '@mui/icons-material/Error';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import UnderlinedLink from 'reservations/base/components/UnderlinedLink';

type BaseErrorCardProps = {
  title: string;
  content: string;
  linkText: string;
  linkHref: string;
};
function BaseErrorCard({
  title,
  content,
  linkHref,
  linkText
}: BaseErrorCardProps) {
  return (
    <Grid container direction="column" alignItems="center">
      <Grid item>
        <Card>
          <CardContent>
            <Grid
              container
              direction="column"
              alignItems="center"
              sx={{ px: '32px', maxWidth: '444px' }}
            >
              <Grid item>
                <ErrorIcon
                  sx={{
                    width: '80px',
                    height: '80px',
                    color: theme => theme.palette.primary.main
                  }}
                />
              </Grid>
              <Grid item sx={{ mb: '16px' }}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '24px',
                    textAlign: 'center'
                  }}
                >
                  {title}
                </Typography>
              </Grid>
              <Grid item sx={{ mb: '32px' }}>
                <Typography sx={{ fontSize: '16px', textAlign: 'center' }}>
                  {content}
                </Typography>
              </Grid>
              <Grid item>
                <UnderlinedLink href={linkHref} openNewTab={false}>
                  {linkText}
                </UnderlinedLink>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default BaseErrorCard;
